// Dollar prices carry cents, so they are rounded to 2 decimal places rather
// than to whole units. Rupee prices stay whole, which is how they are quoted.
const round2 = (value) => Math.round(Number(value) * 100) / 100;

export const convertPrice = (price, currency, selectedCountry) => {
  const USD_TO_INR = process.env.REACT_APP_DOLLAR_PRICE;
  const INR_TO_USD = 1 / USD_TO_INR;

  if (selectedCountry === "INR") {
    if (currency === "USD") {
      let convertedPrice = (price * USD_TO_INR);  // Convert from USD to INR
      // Add shipping charges (40 INR) and GST (18%)
      let priceWithShippingAndGST = convertedPrice + 40; // Adding shipping charges
      priceWithShippingAndGST += priceWithShippingAndGST * 0.18; // Adding 18% GST
      return Math.round(priceWithShippingAndGST); // Round to nearest whole number
    }
    // Price is already in INR, add shipping charges and GST
    let priceWithShippingAndGST = price + 40;  // Adding shipping charges
    priceWithShippingAndGST += priceWithShippingAndGST * 0.18; // Adding 18% GST
    return Math.round(priceWithShippingAndGST); // Round to nearest whole number
  } else if (selectedCountry === "USD") {
    if (currency === "INR") {
      return round2(price * INR_TO_USD); // Convert to USD, keeping cents
    }
    return round2(price); // Already in USD
  }
};

// Everything a customer reads goes through here, so 18.4 and 18 both render as
// "18.40" and "18.00" instead of losing the cents column.
export const formatPrice = (value, selectedCountry) => {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return selectedCountry === "INR" ? "0" : "0.00";
  // Rupees are quoted whole; dollars always show cents.
  return selectedCountry === "INR" ? String(Math.round(amount)) : amount.toFixed(2);
};



// export const convertPrice = (price, currency, selectedCountry) => {
//   const USD_TO_INR = process.env.REACT_APP_DOLLAR_PRICE;
//   const INR_TO_USD = 1 / USD_TO_INR;
